export const MAX_COMMENT_LENGTH = 4000;
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENT_FILE_NAME_LENGTH = 255;

export interface TaskComment {
  readonly id: string;
  readonly taskId: string;
  readonly body: string;
  readonly authorUserId: string;
  readonly authorDisplayName: string;
  readonly authorEmail: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export interface TaskAttachment {
  readonly id: string;
  readonly taskId: string;
  readonly fileName: string;
  readonly contentType: string;
  readonly sizeBytes: number;
  readonly sha256: string;
  readonly uploaderUserId: string;
  readonly uploaderDisplayName: string;
  readonly uploaderEmail: string;
  readonly createdAt: string;
}

export interface TaskCollaborationCounts {
  readonly comments: number;
  readonly attachments: number;
}

export interface CollaborationSummary {
  readonly tasks: Readonly<Record<string, TaskCollaborationCounts>>;
}

export interface TaskCommentList {
  readonly comments: readonly TaskComment[];
}

export interface TaskAttachmentList {
  readonly attachments: readonly TaskAttachment[];
}

export interface CreateCommentRequest {
  readonly body: string;
}
